import { Search, X } from "lucide-react";
import { useI18n } from "../lib/i18n";

/** Cocokkan produk dengan kata kunci pencarian. */
export const matchesQuery = (p, q) => {
  const s = q.trim().toLowerCase();
  if (!s) return true;
  return [p.name, p.name_ja, p.category, p.barcode, p.description]
    .filter(Boolean)
    .some((v) => String(v).toLowerCase().includes(s));
};

/** Kolom pencarian produk di bagian atas halaman toko/resto. */
export const ProductSearch = ({ value, onChange, count, prefix = "shop" }) => {
  const { t } = useI18n();
  return (
    <div className="space-y-2">
      <div className="relative">
        <Search
          size={17}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
        />
        <input
          data-testid={`${prefix}-search-input`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t("search_products_ph")}
          className="w-full h-12 rounded-2xl border border-gray-200 bg-white pl-11 pr-11 text-sm outline-none transition-shadow duration-200 focus:border-primary focus:shadow-[0_0_0_3px_rgba(16,124,86,0.12)]"
        />
        {value && (
          <button
            data-testid={`${prefix}-search-clear`}
            onClick={() => onChange("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 h-7 w-7 grid place-items-center rounded-full text-muted-foreground hover:bg-gray-100"
          >
            <X size={15} />
          </button>
        )}
      </div>
      {value && (
        <p className="text-sm text-muted-foreground" data-testid={`${prefix}-search-count`}>
          {count} {t("search_results_found")}
        </p>
      )}
    </div>
  );
};
